import { useState, useEffect } from "react"
import { serviceAPI } from "../services/serviceService"
import ServiceCard from './ServiceCard'

function ServicesComponent() {
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true)
        const data = await serviceAPI.getActiveServices()
        setServices(data)
        setError(null)
      } catch (err) {
        console.error('Hizmetler yüklenirken hata:', err)
        setError('Hizmetler yüklenirken bir hata oluştu.')
        // Hata durumunda varsayılan verileri göster
        setServices([
          {
            icon: 'fa-fire',
            title: "Doğal Gaz ve Su Tesisatı",
            description: "Yeni ve Eski Binalarda bina içi tesisat işleri. Profesyonel ekipmanlarla güvenli montaj.",
            details: ["Yeni bina tesisatı", "Eski bina dönüşümü", "Güvenli montaj", "Test ve devreye alma"],
            price_start: "Proje bazında fiyatlandırma",
          },
          {
            icon: 'fa-droplet',
            title: "Kaçak Su Tespiti",
            description: "Gelişmiş ekipmanlarla su kaçaklarını tespit ediyoruz. Hızlı ve kesin çözümler.",
            details: ["Profesyonel tespit", "Hızlı müdahale", "Kesin çözüm", "Garantili hizmet"],
            price_start: "200₺'den başlayan fiyatlar",
          },
          {
            icon: 'fa-home',
            title: "Kalorifer Tesisatı",
            description: "Merkezi kalorifer sistemleri kurulumu ve bakımı. Enerji verimli çözümler.",
            details: ["Merkezi sistem kurulumu", "Bakım hizmeti", "Enerji tasarrufu", "Sistem optimizasyonu"],
            price_start: "Proje bazında fiyatlandırma",
          },
          {
            icon: 'fa-cog',
            title: "Kombi Bakım Onarım",
            description: "Kombi Yıllık Bakım Kombi Arıza ve parça değiştirme İşleri. Tüm marka ve modeller.",
            details: ["Yıllık bakım", "Arıza onarımı", "Parça değişimi", "Garanti hizmeti"],
            price_start: "350₺'den başlayan fiyatlar",
          },
          {
            icon: 'fa-snowflake',
            title: "Klima Servisi",
            description: "Yıllık Bakım Onarım arıza giderme montaj işleri. Split ve merkezi sistemler.",
            details: ["Yıllık bakım", "Arıza giderme", "Montaj işleri", "Gaz şarjı"],
            price_start: "250₺'den başlayan fiyatlar",
          },
          {
            icon: 'fa-bolt',
            title: "Beyaz Eşya Servisi",
            description: "Buzdolabı, Çamaşır ve Bulaşık Makinası yıllık bakım onarım, parça değiştirme ve arıza işleri.",
            details: ["Yıllık bakım", "Parça değişimi", "Arıza onarımı", "Kart tamiri"],
            price_start: "150₺'den başlayan fiyatlar",
          },
        ])
      } finally {
        setLoading(false)
      }
    }

    fetchServices()
  }, [])

  if (loading) {
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Hizmetler yükleniyor...</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Buğra Teknik Servis olarak Karabük ve çevre ilçelerde profesyonel teknik servis hizmetleri sunuyoruz.
          </p>
          {error && (
            <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
              {error}
            </div>
          )}
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesComponent
